import axios from "axios";
export const GetCategoryData=()=>axios.get(`/api/categories`);
  
